// src/client/hooks/useAvatarUpload.ts
// Uploads a profile photo to the 'avatars' Supabase Storage bucket and
// updates profiles.avatar_url with the resulting public URL.
import { useState, useCallback } from 'react';
import { supabase } from '@client/lib/supabase';

export function useAvatarUpload(userId: string) {
  const [uploading, setUploading] = useState(false);

  const upload = useCallback(
    async (file: File): Promise<string | null> => {
      setUploading(true);
      try {
        const ext =
          file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
        const path = `${userId}/avatar.${ext}`;

        const { error: uploadError } = await supabase.storage
          .from('avatars')
          .upload(path, file, { upsert: true, contentType: file.type });
        if (uploadError) return null;

        const { data } = supabase.storage.from('avatars').getPublicUrl(path);
        const publicUrl = data.publicUrl;

        await supabase
          .from('profiles')
          .update({ avatar_url: publicUrl })
          .eq('user_id', userId);

        return publicUrl;
      } finally {
        setUploading(false);
      }
    },
    [userId],
  );

  return { upload, uploading };
}
